export default __webpack_public_path__ + "static/og-72375b745a920392a6d67037a9baaab9.jpg";